/**
 * ERM-12599 — the reviewer-materials upload rules the Collab Hub tab states in
 * its hint ("PDF, DOCX or XLSX, up to 25 MB"). They live here so the picker
 * that enforces them and the copy that promises them cannot drift apart.
 *
 * Narrower than the platform's `defaultAllowedFileTypes` on purpose: reviewer
 * materials are review documents, not media.
 */
export const REVIEWER_MATERIAL_ALLOWED_FILE_TYPES = ['pdf', 'docx', 'xlsx'];

/** Reviewer-material upload cap, in MB, matching the tab's stated hint. */
export const REVIEWER_MATERIAL_MAX_FILE_SIZE_MB = 25;

/**
 * Reviewer materials tab copy, verbatim from the ERM-12599 AC. The completed
 * divider string doubles as the tail of the list header
 * ("[X] OF [Y] COMPLETED & SENT TO IRIS").
 */
export const REVIEWER_MATERIALS_COPY = {
  intro:
    'Review submission documents here. When ready, mark this item complete and send the submission to IRIS.',
  footer:
    'Anything you upload here stays with this submission, making it easy for the review team to find and reference later.',
  uploadHeading: 'Upload reviewer materials',
  uploadHint:
    'PDF, DOCX or XLSX, up to 25 MB. Visible to the review team only.',
  completedDivider: 'COMPLETED & SENT TO IRIS',
  empty: 'No reviewer materials have been uploaded for this submission.',
} as const;

export const REVIEWER_DOCUMENT_PAGE_SIZE = 100;
